// Affiliate click tracking + sportsbook link lookup. Every outbound
// affiliate click fires a fire-and-forget POST so we can report
// click volume per partner and tune our affiliate deals.

import axios from "axios";
import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let sportsbooksCache = null;
let inflight = null;

async function fetchOnce() {
  if (sportsbooksCache) return sportsbooksCache;
  if (!inflight) {
    inflight = axios.get(`${API}/affiliates`)
      .then((r) => {
        sportsbooksCache = r.data?.sportsbooks || {};
        return sportsbooksCache;
      })
      .catch(() => { sportsbooksCache = {}; return sportsbooksCache; });
  }
  return inflight;
}

/** Hook that returns the sportsbook partner → URL map. */
export function useSportsbookLinks() {
  const [links, setLinks] = useState(sportsbooksCache || {});
  useEffect(() => {
    let cancelled = false;
    fetchOnce().then((m) => { if (!cancelled) setLinks(m); });
    return () => { cancelled = true; };
  }, []);
  return links;
}

/** Fire-and-forget click recorder. Never throws. */
export function trackAffiliateClick(event) {
  try {
    const payload = {
      partner: event.partner,
      kind: event.kind || "streamer",
      context: event.context || null,
      sport: event.sport || null,
      home_team: event.home_team || null,
      away_team: event.away_team || null,
    };
    // sendBeacon survives page unload; axios keeps a tab in-process navigations
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
      navigator.sendBeacon(`${API}/affiliates/click`, blob);
    } else {
      axios.post(`${API}/affiliates/click`, payload, { timeout: 3000 }).catch(() => {});
    }
  } catch { /* swallow */ }
}
